import { objectToCamel } from 'ts-case-convert';

import type { BillingSettingsResponseParams } from '../@types';

type BillingDataType = Record<string, any>;

export const BillingDefault: BillingDataType[] = [
  {
    id: 'email',
    label: 'Billing E-mail',
    name: 'billingEmail',
    isRequired: false,
  },
  {
    id: 'address1',
    label: 'Billing Address',
    name: 'billingAddress1',
    isRequired: false,
  },
  {
    id: 'address2',
    label: 'Billing Address 2',
    name: 'billingAddress2',
    isRequired: false,
  },
  {
    id: 'city',
    label: 'Billing City',
    name: 'billingCity',
    isRequired: false,
  },
  {
    id: 'zip',
    label: 'Billing Zip',
    name: 'billingZip',
    isRequired: false,
  },
  {
    id: 'state',
    label: 'Billing State',
    name: 'billingState',
    isRequired: false,
  },
  {
    id: 'country',
    label: 'Billing Country',
    name: 'billingCountry',
    isRequired: false,
    options: [
      { name: 'United States', value: 'US' },
      { name: 'Canada', value: 'CA' },
      { name: 'Mexico', value: 'MX' },
      { name: 'Brazil', value: 'BR' },
    ],
  },
];

export const billingConfigApiToObject = (
  data: BillingSettingsResponseParams,
): BillingDataType => {
  const basicBillingFields = objectToCamel(
    Object.fromEntries(
      Object.keys(data)
        .filter(el => el !== 'document') // BE sends improper config
        .map((el: string) => [
          `billing_${el}`,
          {
            required:
              data[el as keyof BillingSettingsResponseParams] === 'mandatory',
          },
        ]),
    ),
  );

  // Fields with improper config from BE fixed.
  const documentFields = data.document
    ? {
        billingDocumentType: { required: data.document === 'mandatory' },
        billingDocumentNumber: { required: data.document === 'mandatory' },
      }
    : {};

  return { ...documentFields, ...basicBillingFields };
};
